<template>
  <div class="private-fund-disclaimer-link" :class="{ 'is-in-footer': inFooter }">
    <button type="button" class="private-fund-disclaimer-link__btn" @click="showDisclaimer = true">
      {{ $t("privateFund.disclaimer.title") }}
    </button>
    <DisclaimerDialog v-model="showDisclaimer" />
  </div>
</template>

<script>
import DisclaimerDialog from "./DisclaimerDialog.vue";

export default {
  name: "DisclaimerFooterLink",
  components: {
    DisclaimerDialog
  },
  props: {
    inFooter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDisclaimer: false
    };
  }
};
</script>

<style scoped lang="less">
.private-fund-disclaimer-link {
  padding: 32px 0 16px;
  text-align: center;

  &.is-in-footer {
    padding: 24px 0 0;
  }

  &__btn {
    border: none;
    background: none;
    padding: 0;
    color: #1677ff;
    font-size: 26px;
    line-height: 40px;
    cursor: pointer;
  }
}

.black-theme .private-fund-disclaimer-link__btn {
  color: #377cfb;
}
</style>
